import React from "react";
import { MessageSquare, FileText } from "lucide-react";
import Card from "components/card";
import AttachmentCard from "components/card/AttachmentCard";

import { API_URL } from "services/apiservice";

const TicketReplyCard = ({ 
    reply,
    department,
    isCurrentUser,
    isCustomer,
    variant = 'it-support'
}) => {

    const trp_message = reply?.tic_message;
    const created_at_ago = reply?.created_at_ago;
    const user_name = reply?.user_name;
    const attachment = reply?.attachment;

    const config = {
        'it-support': {
            customerIconClass: 'bg-purple-100 text-purple-700',
            staffIconClass: 'bg-blue-100 text-blue-700',
            defaultIconClass: 'bg-blue-100 text-blue-700',
            labelMap: {
                currentCustomer: "Your Reply",
                currentStaff: "Your Response",
                customer: "Customer Reply",
                default: "Department Response"
            }
        },
        'hr-support': {
            customerIconClass: 'bg-pink-100 text-pink-700',
            staffIconClass: 'bg-pink-100 text-pink-700',
            defaultIconClass: 'bg-pink-100 text-pink-700',
            labelMap: {
                currentCustomer: "Your Reply",
                currentStaff: "Your Response",
                customer: "Customer Reply",
                default: "People & Culture Team"
            }
        },
        'partner-service': {
            customerIconClass: 'bg-purple-100 text-purple-700',
            staffIconClass: 'bg-purple-100 text-purple-700',
            defaultIconClass: 'bg-purple-100 text-purple-700',
            labelMap: {
                currentCustomer: "Your Reply",
                currentStaff: "Your Response",
                customer: "Customer Reply",
                default: "Partner & Service Team"
            }
        }
    };

    const currentConfig = config[variant] || config['it-support'];

    const getReplyLabel = () => {
        if (isCurrentUser && isCustomer) return currentConfig.labelMap.currentCustomer;
        if (isCurrentUser && !isCustomer) return currentConfig.labelMap.currentStaff;
        if (isCustomer) return currentConfig.labelMap.customer;
        if (variant === 'hr-support') return user_name || currentConfig.labelMap.default;
        return `${department} ${currentConfig.labelMap.default}`;
    };

    const getIconClass = () => {
        if (isCustomer && variant === 'it-support') return currentConfig.customerIconClass;
        return currentConfig.defaultIconClass;
    };

    const attachmentData = variant === 'hr-support' && attachment ? {
        att_id: attachment.id,
        att_filename: attachment.filename,
        att_filesize: attachment.size
    } : attachment;

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-2 rounded-xl border-2 border-slate-200 overflow-hidden dark-mode-card">
            <div className="p-4">
                <div className="flex items-start gap-3 mb-6">
                    <div className={`p-2 rounded-xl ${getIconClass()}`}>
                        <MessageSquare className="w-4 h-4" />
                    </div>
                    <div className="flex-1">
                        <div className="flex items-center justify-between mb-1">
                            <div>
                                <p className="font-semibold text-[13px] title-text">{getReplyLabel()}</p>
                            </div>
                            <span className="text-[11px] muted-text">{created_at_ago}</span>
                        </div>
                        <p className="text-[11px] muted-text whitespace-pre-wrap break-words">{trp_message}</p>
                    </div>
                </div>
                {attachmentData && (
                    <div className="space-y-2 sm:space-y-2.5">
                        <AttachmentCard
                            attachment={{
                                id: attachmentData?.att_id,
                                name: attachmentData?.att_filename,
                            }}
                            onDownload={(file) => {
                                window.open(
                                    `${API_URL}/download/attachment/${file.id}`,
                                    "_blank"
                                );
                            }}
                            onView={(file) => {
                                window.open(
                                    `${API_URL}/preview/attachment/${file.id}`,
                                    "_blank"
                                );
                            }}
                        />
                    </div>
                )}
            </div>
        </Card>
    );
};

export default TicketReplyCard;